export default __webpack_public_path__ + "static/media/Pot2.68017581.svg";